export default "__VITE_ASSET__3869d760__"